/**
 * WEB-2058 — генератор идентификаторов блоков/экранов, вынесен из хранилища
 * редактора отдельным модулем: его читают и хранилище, и заготовки блоков
 * (`blockDefaults.ts`), а импорт хранилища из заготовок дал бы кольцо.
 */
export function generateId(): string {
  // RFC-4122 v4 via native Web Crypto — globally unique across funnels so
  // template-clones never collide (WEB-167). Available in browsers and jsdom.
  return crypto.randomUUID();
}
